import ListPageView from "../../components/ListPageView"
import PageSidebarContent from "../../components/sidebars/PageSidebarContent"
import ActivityLogSidebar from "../../components/sidebars/ActivityLogSidebar"

export default function HarmReductionActivityLog() {
  const ID_TEMPLATE = "harm_reduction_activity_log"
  const ID_BLOCKS = ["activity__harm_reduction_log", "activity"]

  const listViewCols = [
    {
      header: "Date",
      field: "activity_date",
      block: "activity",
      type: "date",
    },
    {
      header: "Location",
      field: "activity__location_ids",
      block: "activity",
      type: "location",
    },
    {
      header: "Activity Name",
      field: "activity_name_hr",
      block: "activity__harm_reduction_log",
      type: "string",
    },
    {
      header: "Activity Type",
      field: "activity_type_hr",
      block: "activity__harm_reduction_log",
      type: "activity_type",
    },
    {
      header: "Staff",
      field: "staff_full_name",
      block: "activity",
      type: "staff",
    },
    {
      header: "Attendees/Distributed",
      field: "activity_attendance_hr|activity_type_distribution_number",
      block: "activity__harm_reduction_log",
      type: "attendees",
    },
    {
      header: "Program ID",
      field: "activity__program_identity_ids",
      block: "activity",
      type: "program",
    },
  ]

  return (
    <>
      <PageSidebarContent>
        <ActivityLogSidebar />
      </PageSidebarContent>
      <div className="main-content">
        <ListPageView
          idTemplate={ID_TEMPLATE}
          idBlocks={ID_BLOCKS}
          columns={listViewCols}
        />
      </div>
    </>
  )
}
